import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { IDealOption } from '../../types/CreateDealForm';

// Returns the worksheet's options with the rent choice for `name` applied. Renting doesn't cost
// anything up front, so a rent-only option is kept at 0 purchased/$0 - and dropped again once the
// rent is turned off and nothing is being purchased.
export const setOptionRent = (options: IDealOption[], name: string, rent: boolean): IDealOption[] => {
  const existingOption = options.find((option) => option.name === name);
  const otherOptions = options.filter((option) => option.name !== name);

  if (!rent && !existingOption?.purchaseAmount) return otherOptions;
  return [...otherOptions, { purchaseAmount: 0, amount: 0, ...existingOption, name, rent }];
};

// Yes/No card for options that can be rented instead of (or as well as) purchased, e.g. parking
const RentOptionCard = (props: ChildProps) => {
  const { name, rent, onChange } = props;

  return (
    <Box sx={{ p: 2.5, border: '1px solid #c4c4c4', borderRadius: '4px', height: '100%' }}>
      <Typography component="h2" sx={{ m: 0, mb: 1, fontSize: '16px', fontWeight: 600, textTransform: 'uppercase' }}>
        Would you like to rent {name}?
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        // Selected choice in the StoreyView green (theme primary)
        sx={{
          '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: 'primary.main',
            color: '#fff',
            '&:hover': { backgroundColor: 'primary.dark' },
          },
        }}
        value={rent ? 'yes' : 'no'}
        // MUI sends null when the selected button is clicked again - always keep one selected
        onChange={(event, value) => (value === null ? null : onChange(value === 'yes'))}
      >
        <ToggleButton value="no">NO</ToggleButton>
        <ToggleButton value="yes">YES</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

interface ChildProps {
  name: string;
  rent: boolean;
  onChange: (rent: boolean) => void;
}

export default RentOptionCard;
